import { HtmlPlayer } from "../Players/HtmlPlayer.js";
import { IframePlayer } from "../Players/IframePlayer.js";
import { VideoFailed } from "../VideoFailed.js";
import { canPlay } from "./canPlay.js";
const Players = (allowDirectVideoLinks)=>{
    const playersList = [
        {
            key: 'failed',
            name: 'failed',
            canPlay: ()=>false,
            player: VideoFailed
        },
        {
            key: 'rutube',
            name: 'Rutube',
            canPlay: canPlay.rutube,
            player: IframePlayer
        },
        {
            key: 'vkvideo',
            name: 'VkVideo',
            canPlay: canPlay.vkvideo,
            player: IframePlayer
        }
    ];
    if (allowDirectVideoLinks) playersList.push({
        key: 'html',
        name: 'html',
        canPlay: canPlay.html,
        canEnablePIP: ()=>{
            const userAgent = navigator.userAgent.toLowerCase();
            if (userAgent.indexOf('firefox') > -1) return false;
            return true;
        },
        player: HtmlPlayer
    });
    return playersList;
};
export { Players };
